var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgBookmarkEmpty = function SvgBookmarkEmpty(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1b1f",
    d: "m14.125 19.486-4.167 1.792q-.9.388-1.71-.15-.81-.536-.81-1.498V6.883q0-.77.515-1.285.516-.516 1.285-.516h9.774q.77 0 1.285.516.516.515.515 1.285V19.63q0 .961-.81 1.499-.81.537-1.71.149zm0-1.252 4.608 1.99q.344.15.654-.065a.67.67 0 0 0 .31-.579V6.883a.66.66 0 0 0-.213-.472.66.66 0 0 0-.472-.214H9.238a.66.66 0 0 0-.472.214.66.66 0 0 0-.214.472V19.58a.67.67 0 0 0 .31.579.64.64 0 0 0 .655.064z"
  })));
};
export default SvgBookmarkEmpty;